import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useTranslations } from "use-intl";

export default function NotFoundError({ routeTo }: { routeTo: string }) {
  const navigate = useNavigate();
  const t = useTranslations("error");
  return (
    <div className="h-svh">
      <div className="m-auto flex h-full w-full flex-col items-center justify-center gap-2">
        <h1 className="text-[7rem] font-bold leading-tight">404</h1>
        <span className="font-medium">{t("404_title")}</span>
        <p className="text-center text-muted-foreground">
          {t.rich("404_desc", { br: () => <br /> })}
        </p>
        <div className="mt-6 flex gap-4">
          <Button variant="outline" onClick={() => navigate(-1)}>
            {t("go_back")}
          </Button>
          <Button onClick={() => navigate(routeTo)}>{t("back_to_home")}</Button>
        </div>
      </div>
    </div>
  );
}
